/**
 * Le chiavi dei moduli, isolate da tutto il resto.
 *
 * Stanno in un file senza dipendenze perché le usano sia il registro dei
 * moduli sia gli schemi dell'API: se vivessero nel registro, il data layer
 * dovrebbe importare componenti React per conoscere un'enumerazione.
 */
export const MODULE_KEYS = [
  'ricerca',
  'collection',
  'presentazione',
  'analitica',
  'trends',
  'recommender',
  'onirica',
  'generativa',
  'utilizzo',
  'impostazioni',
  'amministratore',
  'aziende',
] as const

export type ModuleKey = (typeof MODULE_KEYS)[number]

/**
 * I moduli opzionali: quelli che si attivano e disattivano su richiesta e
 * hanno un prezzo. Gli altri fanno parte della piattaforma e ci sono sempre.
 */
export const ADDON_MODULE_KEYS = [
  'analitica',
  'trends',
  'recommender',
  'onirica',
  'generativa',
] as const satisfies readonly ModuleKey[]

export type AddonModuleKey = (typeof ADDON_MODULE_KEYS)[number]

export function isAddonModule(key: ModuleKey): key is AddonModuleKey {
  return (ADDON_MODULE_KEYS as readonly ModuleKey[]).includes(key)
}
